import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from "@angular/core";
import {DxGridComponent} from "./ui/components/dx-grid-component";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {DxGridToolbarComponent} from "./ui/components/toolbar/dx-grid-toolbar.component";
import { AgGridModule } from 'ag-grid-angular';
import {DxNumericCellEditorComponent} from "./ui/components/editors/nuneric/dx-numeric-cell-editor.component";
import {DxLinkCellRenderComponent} from "./ui/components/renders/link/dx-link-cell-render.component";
import {DxBaseCellRenderComponent} from "./ui/components/renders/dx-base-cell-render.component";
import {DxCurrencyCellRenderComponent} from "./ui/components/renders/currency/dx-currency-cell-render.component";
import {DxDictionaryCellRenderComponent} from "./ui/components/renders/dictionary/dx-dictionary-cell-render.component";
import { DxCheckboxCellRenderComponent } from './ui/components/renders/checkbox/dx-checkbox-cell-render.component';
import { DxCheckboxCellEditorComponent } from './ui/components/editors/checkbox/dx-checkbox-cell-editor.component';
import { DxDatetimeCellRenderComponent } from './ui/components/renders/datetime/dx-datetime-cell-render.component';
import { DxDictionaryFloatingFilterComponent } from './ui/components/renders/dictionary-filter/dx-dictionary-floating-filter.component';


@NgModule({
  declarations: [
    DxGridComponent,
    DxGridToolbarComponent,
    DxNumericCellEditorComponent,
    DxBaseCellRenderComponent,
    DxLinkCellRenderComponent,
    DxCurrencyCellRenderComponent,
    DxDictionaryCellRenderComponent,
    DxCheckboxCellRenderComponent,
    DxCheckboxCellEditorComponent,
    DxDatetimeCellRenderComponent,
    DxDictionaryFloatingFilterComponent
  ],
  exports: [
    DxGridComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    AgGridModule.withComponents([
      DxNumericCellEditorComponent,
      DxBaseCellRenderComponent,
      DxLinkCellRenderComponent,
      DxCheckboxCellRenderComponent,
      DxCheckboxCellEditorComponent,
      DxCurrencyCellRenderComponent,
      DxDictionaryCellRenderComponent,
      DxDatetimeCellRenderComponent,
      DxDictionaryFloatingFilterComponent
    ])
  ],
  providers: [],
  bootstrap: []
})
export class DxGridModule {

}
